import { State } from 'xstate';

import { modals } from './modals';

type ModalsMachine = typeof modals;

type ModalsState = State<ModalsMachine['context']>;

export const getCreatePaymentProfile = (machineState: ModalsState) => ({
  isOpen: machineState.matches('createPaymentProfile'),
  meta: machineState.context.createPaymentProfile,
});

export const getAddonsConfiguration = (machineState: ModalsState) => ({
  isOpen: machineState.matches('addonsConfiguration'),
  meta: machineState.context.componentsAllocation,
});

export const getResumeSubscription = (machineState: ModalsState) => ({
  isOpen: machineState.matches('resumeSubscription'),
  meta: machineState.context.resumeSubscription,
});

export const getPauseSubscription = (machineState: ModalsState) => ({
  isOpen: machineState.matches('pauseSubscription'),
  meta: machineState.context.pauseSubscription,
});

export const getCancelSubscription = (machineState: ModalsState) => ({
  isOpen: machineState.matches('cancelSubscription'),
  meta: machineState.context.cancelSubscription,
});

export const getDeletePaymentMethod = (machineState: ModalsState) => ({
  isOpen: machineState.matches('deletePaymentProfile'),
  meta: machineState.context.deletePaymentProfile,
});

export const getChangePaymentMethod = (machineState: ModalsState) => ({
  isOpen: machineState.matches('changePaymentProfile'),
  meta: machineState.context.changePaymentProfile,
});

export const getPreviewPaymentMethod = (machineState: ModalsState) => ({
  isOpen: machineState.matches('previewPaymentProfile'),
  meta: machineState.context.previewPaymentProfile,
});

export const getUndoCancelation = (machineState: ModalsState) => ({
  isOpen: machineState.matches('undoCancelation'),
  meta: machineState.context.undoCancelation,
});
export const getReactivateSubscription = (machineState: ModalsState) => ({
  isOpen: machineState.matches('reactivateSubscription'),
  meta: machineState.context.reactivateSubscription,
});
export const getChangeSubscriptionPlan = (machineState: ModalsState) => ({
  isOpen: machineState.matches('changeSubscriptionPlan'),
  meta: machineState.context.changeSubscriptionPlan,
});

export const getThreeDsConfirmation = (machineState: ModalsState) => ({
  isOpen: machineState.matches('threeDSecure'),
  meta: machineState.context.threeDSecure,
});
export const getAddCoupon = (machineState: ModalsState) => ({
  isOpen: machineState.matches('addCoupon'),
  meta: machineState.context.addCoupon,
});
export const modalsSelectors = {
  getAddCoupon,
  getCreatePaymentProfile,
  getAddonsConfiguration,
  getResumeSubscription,
  getPauseSubscription,
  getCancelSubscription,
  getUndoCancelation,
  getDeletePaymentMethod,
  getChangePaymentMethod,
  getPreviewPaymentMethod,
  getReactivateSubscription,
  getChangeSubscriptionPlan,
  getThreeDsConfirmation,
};
